<template>
  <div>
    <v-dialog
      v-model="addEditDialog"
      persistent
      max-width="800px"
    >
      <v-card style="border-radius: 16px">
        <form @submit.prevent="submitForm()">
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            >
              <span class="headline">{{ form.export_order_id ? $t('customer.updateExportOrderTitle') : $t('customer.addExportOrderTitle') }}</span>
            </v-flex>
            <v-flex xs1>
              <v-btn
                flat
                icon
                class="close"
                @click="$emit('close')"
              >
                <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
              </v-btn>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <div class="row mx-1">
              <div class="col-md-6">
                <v-select
                  autocomplete
                  :items="customers"
                  item-value="value"
                  v-model="form.customer_id_fk"
                  :error-messages="errors.collect('Customer')"
                  data-vv-name="Customer"
                  :label="$t('columns.customer') + '*'"
                  v-validate="'required'"
                >
                </v-select>
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('customer.productDescription') + '*'"
                  v-model="form.product_name"
                  :error-messages="errors.collect('Product Description')"
                  v-validate="'required'"
                  data-vv-name="Product Description"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('columns.quantity') + '*'"
                  v-model="form.quantity"
                  :error-messages="errors.collect('Quantity')"
                  v-validate="'required|numeric|min_value:1'"
                  data-vv-name="Quantity"
                />
              </div>

              <div class="col-md-4">
                <v-text-field
                  :label="$t('columns.weight')"
                  v-model="form.weight"
                />
              </div>
              <div class="col-xs-2">
                <v-select
                  :items="weightUnitList"
                  v-model="form.weight_unit"
                  :error-messages="errors.collect('Weight Unit')"
                  data-vv-name="Weight Unit"
                  v-validate="'required'"
                  autocomplete
                />
              </div>

              <div class="col-xs-12">{{ $t('customer.dimensionsPerPackageLabel') }} <span class="inch-div">(inch)</span></div>
              <div class="col-xs-3">
                <v-text-field
                  v-model="form.volume_l"
                  :label="$t('customer.length')"
                  type="number"
                />
              </div>
              <div class="col-xs-3">
                <v-text-field
                  v-model="form.volume_w"
                  :label="$t('customer.width')"
                  type="number"
                />
              </div>
              <div class="col-xs-3">
                <v-text-field
                  v-model="form.volume_h"
                  :label="$t('customer.height')"
                  type="number"
                />
              </div>
              <div class="col-xs-3">
                <input
                  type="file"
                  accept="image/*"
                  name="image"
                  id="image"
                  style="display: none"
                  @input="form.image = $event.target.files[0]"
                >
                <label
                  for="image"
                  class="btn btn-primary"
                >
                  <i class="fa fa-upload"></i> {{ $t('orders.uploadImage') }}
                  <i class="pl-1">{{ form.image ? form.image.name : '' }}</i>
                </label>
              </div>
            </div>

            <v-divider></v-divider>

            <div class="row mx-1">
              <div class="col-xs-12">
                <div style="font-size: 16px">{{ $t('customer.receiverDetail') }}</div>
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('columns.name') + '*'"
                  v-model="form.receiver_name"
                  :error-messages="errors.collect('Name')"
                  v-validate="'required'"
                  data-vv-name="Name"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('columns.phone') + '*'"
                  v-model="form.receiver_phone"
                  :error-messages="errors.collect('Phone')"
                  v-validate="'required'"
                  data-vv-name="Phone"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('columns.address') + '*'"
                  v-model="form.receiver_address"
                  :error-messages="errors.collect('Address')"
                  v-validate="'required'"
                  data-vv-name="Address"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('columns.city') + '*'"
                  v-model="form.receiver_city"
                  :error-messages="errors.collect('City')"
                  v-validate="'required'"
                  data-vv-name="City"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('customer.zipCode') + '*'"
                  v-model="form.receiver_zip_code"
                  :error-messages="errors.collect('Zip Code')"
                  v-validate="'required|integer'"
                  type="number"
                  data-vv-name="Zip Code"
                />
              </div>

              <div class="col-md-6">
                <v-select
                  autocomplete
                  :items="countryList"
                  item-value="value"
                  v-model="form.to_country_id_fk"
                  :error-messages="errors.collect('Destination')"
                  data-vv-name="Destination"
                  :label="$t('customer.destination') + '*'"
                  v-validate="'required'"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  :label="$t('columns.email') + '*'"
                  type="email"
                  v-model="form.receiver_email"
                />
              </div>
            </div>

          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="$emit('close')"
              outline
              color="normal"
              class="mr-4"
            >
              {{ $t('common.cancel') }}
            </v-btn>

            <v-btn
              type="submit"
              style="height:auto" class="rtl-mr-4pct"
              outline
              color="success"
            >
              {{ $t('common.save') }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  props: {
    addEditDialog: { type: Boolean, default: false },
    form: { type: Object, default: () => { } },
    customers: { type: Array, default: () => [] }
  },

  mounted() {
    this.getCountryList()

    // if edit mode get order data
    if (this.$route.params.id) {
      this.getOrder()
    }
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      weightUnitList: [
        { text: 'KG', value: 'kg' },
        { text: 'LB', value: 'lb' }
      ],
      countryList: [],
      loading: false
    }
  },

  methods: {
    getCountryList() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/country/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.countryList = response.data.map((item) => {
            return { text: item.country_name, value: item.country_id }
          })
        })
    },

    getOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/customer_order_detail/${this.$route.params.id}`, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.form = response.data.data[0]
        })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let token = localStorage.getItem('access_token')

          let formData = new FormData()
          for (let key in this.form) {
            if (this.form[key]) {
              formData.append(key, this.form[key])
            }
          }

          if (this.form.export_order_id) {
            formData.append('_method', 'put')
            axios
              .post(`api/export-order/${this.form.export_order_id}/update`, formData, {
                headers: { Authorization: 'Bearer ' + token }
              })
              .then(() => {
                this.loading = false
                this.$validator.reset()
                this.$emit('close')
                this.$emit('update-table')
                swal(this.$t('common.success'), this.$t('common.updatedSuccessfully'), 'success')
              })
              .catch(error => {
                this.loading = false
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              })
          } else {
            axios
              .post('api/export-order/store', formData, { headers: { Authorization: 'Bearer ' + token } })
              .then(() => {
                this.loading = false
                this.$validator.reset()
                this.$emit('close')
                this.$emit('update-table')
                swal(this.$t('common.success'), this.$t('common.addedSuccessfully'), 'success')
              })
              .catch(error => {
                this.loading = false
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.panel-flat {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/exportOrder/addEditExportOrder.vue